import React from 'react';
import { isNumber } from 'lodash';
import { View } from 'react-native';
import { metrics } from 'src/themes/Metrics';

interface Props {
  height?: 'tiny' | 'small' | 'medium' | 'large' | 'huge' | 'extraHuge' | number;
  width?: 'tiny' | 'small' | 'medium' | 'large' | 'huge' | 'extraHuge' | number;
}

export const SizedBox = ({ height = 'large', width = 'large' }: Props) => {
  return (
    <View
      style={{
        height: isNumber(height) ? height : metrics[height],
        width: isNumber(width) ? width : metrics[width],
      }}
    />
  );
};
